// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      materialTransportHazardOptions: [
        "Chemicals",
        "Radiocative",
        "Spill",
        "Wide"
      ],
      // eslint-disable-next-line
      materialStorageTypeOptions: [
        "Shelf",
        "Box",
        "Crate",
        "Cage",
        "Vessel",
        "Various"
      ],
      // eslint-disable-next-line
      materialCertificateOptions: [
        "Amusement",
        "Boiler",
        "Booms",
        "Building",
        "Conformity",
        "Crane",
        "Electrical",
        "Ex",
        "Gas",
        "ISO",
        "Lift",
        "Marine",
        "Pressure Vessel",
        "Transport",
        "Other"
      ],
      // eslint-disable-next-line
      materialStorageTransportOptions: [
        "Manual",
        "Trolley",
        "Forklift",
        "Vehicle"
      ],
      // eslint-disable-next-line
      materialAvailabilityOptions: [
        "Free",
        "Limited",
        "Obsolete"
      ],
      // eslint-disable-next-line
      materialReplacementOptions: [
        "NA",
        "Engineering",
        "Identified"
      ],
      // eslint-disable-next-line
      materialRepairOptions: [
        "Replace",
        "Recertify",
        "Repair",
        "Refurbish"
      ],
      // eslint-disable-next-line
      materialRecycleOptions: [
        "NA",
        "Metal",
        "Ferrous",
        "Non Ferrous",
        "Paper",
        "Green",
        "Glass",
        "Battery",
        "Timber",
        "E-Waste",
        "Other"
      ],
      // eslint-disable-next-line
      materialReplacementOptions: [
        "NA",
        "Engineering",
        "Identified"
      ],
      // eslint-disable-next-line
      materialEngingeeringOptions: [
        "Like for Like",
        "Procedure",
        "Workpack"
      ],
      // eslint-disable-next-line
      materialSupplyOptions: [
        "Local",
        "Remote",
        "State",
        "Overseas"
      ]
    };
  }
};
